import * as Yup from 'yup';

export const schema = Yup.object().shape({
  name: Yup.string().required('Campo requerido'),
  price: Yup.number()
    .transform((value, originalValue) => {
      return originalValue === '' ? undefined : value;
    })
    .required('Campo requerido')
    .typeError('Debe ser un número')
    .integer('Debe ser un número entero'),
  value: Yup.number()
    .transform((value, originalValue) => {
      return originalValue === '' ? undefined : value;
    })
    .required('Campo requerido')
    .typeError('Debe ser un número')
    .integer('Debe ser un número entero'),
  thumbnail: Yup.string(),
});
